import ApiService from "@/api.service";
import API from "@/API";


export const GET_LIST_CATEGORY_POST = "listCategoryPost";
export const GET_DETAIL_CATEGORY_POST = "detailCategoryPost";
export const SAVE_CATEGORY_POST = "saveCategoryPost";
export const UPDATE_CATEGORY_POST = "updateCategoryPost";
export const DELETE_CATEGORY_POST = "deleteCategoryPost";
export const UPLOAD_CATEGORY_POST_IMAGE = "uploadCategoryPost";
export const GET_DATA_SEARCH_CATEGORY_POST = "getDataSearchCategoryPost";

export const SET_DATA_SEARCH_CATEGORY_POST = "setDataSearchCategoryPost";
export const SET_LIST_CATEGORY_POST = "setListCategoryPost";
export const SET_DETAIL_CATEGORY_POST = "setDetailCategoryPost";

const state = {
    categoryPost: [],
    category: {},
    dataSearch: []

};

const getters = {
    categoryPost(state) {
        return state.categoryPost;
    },
    categoryPostDetail(state) {
        return state.category;
    },

    dataSearchCategoryPost(state) {
        return state.dataSearch;
    }
};

const actions = {
    [GET_LIST_CATEGORY_POST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CATEGORY_POST, payload).then(({ data }) => {
                if (data.status) {
                    console.log("ok")
                    context.commit(SET_LIST_CATEGORY_POST, data);
             
                }
                resolve(data);
            });
        });
    },

    [GET_DATA_SEARCH_CATEGORY_POST](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_CATEGORY_POST_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH_CATEGORY_POST, data.data.categories);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_CATEGORY_POST](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_CATEGORY_POST}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CATEGORY_POST, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_CATEGORY_POST_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_CATEGORY_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [SAVE_CATEGORY_POST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_CATEGORY_POST}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_CATEGORY_POST](context, payload) {
        console.log(payload)
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_CATEGORY_POST}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_CATEGORY_POST](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_CATEGORY_POST}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_CATEGORY_POST](state, data) {
       state.categoryPost =  data.data
    },
    [SET_DETAIL_CATEGORY_POST](state, data) {
        state.category = data.data;
    },

    [SET_DATA_SEARCH_CATEGORY_POST](state, data) {
        state.dataSearch = data
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};